import { t } from '../i18n.js';
import { exitAndRemove } from './motion.js';

let currentHandle = null;
let currentContainer = null;

/**
 * Show a persistent "new version available" toast.
 *
 * Singleton: a second call while one is mounted returns the existing handle.
 *
 * @param {object} opts
 * @param {function} opts.onReload  - called when the user clicks Reload (toast stays mounted)
 * @param {function} opts.onDismiss - called when the user clicks Dismiss (toast is removed)
 * @returns {{ close(): void }}
 */
export function showUpdateToast({ onReload, onDismiss }) {
  if (currentHandle && currentContainer && currentContainer.isConnected) {
    return currentHandle;
  }
  currentHandle = null;

  const container = document.createElement('div');
  container.className =
    'fixed bottom-4 inset-x-0 mx-auto flex justify-center z-60 pointer-events-none';

  const card = document.createElement('div');
  card.className =
    'pointer-events-auto rounded-xl bg-primary-600 text-white shadow-lg px-4 py-3 flex flex-col sm:flex-row items-center gap-3 max-w-md anim-fade-up';

  const message = document.createElement('span');
  message.className = 'min-w-0';
  message.textContent = t('update.toast.message');

  const reloadBtn = document.createElement('button');
  reloadBtn.type = 'button';
  reloadBtn.className = 'btn btn-primary whitespace-nowrap shrink-0';
  reloadBtn.textContent = t('update.toast.reload');
  reloadBtn.addEventListener('click', () => {
    onReload();
  });

  const dismissBtn = document.createElement('button');
  dismissBtn.type = 'button';
  dismissBtn.className = 'btn btn-secondary whitespace-nowrap shrink-0';
  dismissBtn.textContent = t('update.toast.dismiss');
  dismissBtn.addEventListener('click', () => {
    onDismiss();
    closeToast();
  });

  card.append(message, reloadBtn, dismissBtn);
  container.append(card);
  document.body.append(container);
  currentContainer = container;

  function closeToast() {
    if (currentHandle === null) return;
    currentHandle = null;
    currentContainer = null;
    exitAndRemove(container, 'anim-fade-out');
  }

  currentHandle = { close: closeToast };
  return currentHandle;
}
